import React from "react";

const SkeletonUserCard = () => {
  return (
    <div className="skeleton-card">
      <div
        className="skeleton skeleton-circle"
        style={{ width: 56, height: 56, flexShrink: 0 }}
      />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <div className="skeleton" style={{ width: "60%", height: 16 }} />
        <div className="skeleton" style={{ width: "35%", height: 12 }} />
      </div>
    </div>
  );
};

export default SkeletonUserCard;
